import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { NavLink, Navigate, useNavigate } from "react-router-dom";
import { Container, FlexBox } from "../../styles/Common";
import { ReactComponent as IcoClose } from "../../styles/images/ico_close.svg";
import { ReactComponent as IcoMenu } from "../../styles/images/ico_menu.svg";
import { ReactComponent as Logo } from "../../styles/images/ico_logo.svg";
import { ReactComponent as UserIcon } from "../../styles/images/ico_user_icon.svg";
import UserIconImg from "../../styles/images/img_user.png";
import { ReactComponent as IcoArrowCol } from "../../styles/images/ico_arrow_col.svg";
import { ReactComponent as IcoArrow } from "../../styles/images/ico_arrow.svg";
import IcoArrowDown from "../../styles/images/ico_arrow_down.svg";
import { useDispatch, useSelector } from "react-redux";
import { getToken, returnLoginStatus } from "../hooks/authFunc";
import { replaceCommas } from "../hooks/basicFunc";
import { userActions } from "../../store/slices/userSlice";

const Header = (props) => {
  const { isOpen, setOpen } = props;
  const isLogin = returnLoginStatus();
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.user.userInfo);
  const accessToken = getToken();
  const dispatch = useDispatch();

  useEffect(() => {
    const params = {};
    if (returnLoginStatus()) {
      dispatch(userActions.fetchUserLookup({ params, accessToken }));
    }
    if (isOpen) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "unset";
  }, [isOpen]);

  return (
    <HeaderWrap>
      <Container>
        <header>
          <button
            onClick={() => {
              setOpen(!isOpen);
            }}
          >
            <IcoMenu />
          </button>

          <h2>
            {props.title ? (
              props.title
            ) : (
              <Logo
                onClick={() => {
                  navigate("/home");
                }}
                className="pointer"
              />
            )}
          </h2>

          <UserIconWrap>
            {isLogin ? (
              <UserIcon
                className="pointer"
                onClick={() => {
                  navigate("/mypage/edit");
                }}
              />
            ) : (
              ""
            )}
          </UserIconWrap>
        </header>
        <div className={`panel ${isOpen ? "open" : "close"}`}>
          <header>
            <div></div>
            <h1
              onClick={() => {
                navigate("/home");
              }}
            >
              <Logo className="pointer" />
            </h1>
            <button onClick={() => setOpen(!isOpen)} className="close">
              <IcoClose />
            </button>
          </header>
          <InfoBox islogin={isLogin.toString()}>
            {isLogin ? (
              <>
                <UserBox>
                  <UserImg src={UserIconImg} alt="user" />
                  <p className="userName">
                    <span>{userInfo.name}</span> 님
                  </p>
                </UserBox>
                <PointBox>
                  <PointTitle>보유 뮤포인트</PointTitle>
                  <UserPoint>
                    <span>{replaceCommas(userInfo.mup)} </span> P
                  </UserPoint>
                </PointBox>
              </>
            ) : (
              <p>
                회원서비스 이용을 위해{" "}
                <NavLink to="/login" className="navLogin">
                  로그인
                </NavLink>{" "}
                해주세요!
              </p>
            )}
          </InfoBox>
          <nav>
            <ul>
              <li>
                <p>
                  <NavLink to="/introduce" onClick={() => setOpen(!isOpen)}>
                    소개
                    <IcoArrow />
                  </NavLink>
                </p>
              </li>
              <li>
                <details>
                  <summary>
                    <p>제휴</p>
                  </summary>
                  <ul>
                    <li>
                      <NavLink
                        to="/introduce/partners"
                        onClick={() => setOpen(!isOpen)}
                      >
                        <p>
                          제휴사 소개
                          <IcoArrowCol />
                        </p>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/guide" onClick={() => setOpen(!isOpen)}>
                        <p>
                          제휴 안내
                          <IcoArrowCol />
                        </p>
                      </NavLink>
                    </li>
                  </ul>
                </details>
              </li>
              <li>
                <details>
                  <summary>
                    <p>AMO</p>
                  </summary>
                  <ul>
                    <li>
                      <NavLink to="/amo/init" onClick={() => setOpen(!isOpen)}>
                        <p>
                          AMO 포인트 교환
                          <IcoArrowCol />
                        </p>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/amo/history"
                        onClick={() => setOpen(!isOpen)}
                      >
                        <p>
                          AMO 거래내역
                          <IcoArrowCol />
                        </p>
                      </NavLink>
                    </li>
                  </ul>
                </details>
              </li>
              <li>
                <details>
                  <summary>
                    <p>포인트</p>
                  </summary>
                  <ul>
                    <li>
                      <NavLink
                        to="/point/change"
                        onClick={() => setOpen(!isOpen)}
                      >
                        <p>
                          포인트 교환
                          <IcoArrowCol />
                        </p>
                      </NavLink>
                    </li>
                  </ul>
                </details>
              </li>
              <li>
                <details>
                  <summary>
                    <p>마이페이지</p>
                  </summary>
                  <ul>
                    <li>
                      <NavLink
                        to="/mypage/edit"
                        onClick={() => setOpen(!isOpen)}
                      >
                        <p>
                          회원정보
                          <IcoArrowCol />
                        </p>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/mypage/point"
                        onClick={() => setOpen(!isOpen)}
                      >
                        <p>
                          MY포인트
                          <IcoArrowCol />
                        </p>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/mypage/inquiry"
                        onClick={() => setOpen(!isOpen)}
                      >
                        <p>
                          1:1 문의내역
                          <IcoArrowCol />
                        </p>
                      </NavLink>
                    </li>
                  </ul>
                </details>
              </li>
              <li>
                {/* <p>
                  <NavLink to="introduce">
                    고객센터
                    <IcoArrow />
                  </NavLink>
                </p> */}
                <details>
                  <summary>
                    <p>고객센터</p>
                  </summary>
                  <ul>
                    <li>
                      <NavLink
                        to="/service/notice"
                        onClick={() => setOpen(!isOpen)}
                      >
                        <p>
                          공지사항
                          <IcoArrowCol />
                        </p>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/service/faq"
                        onClick={() => setOpen(!isOpen)}
                      >
                        <p>
                          FAQ
                          <IcoArrowCol />
                        </p>
                      </NavLink>
                    </li>
                  </ul>
                </details>
              </li>
              <li>
                <p>
                  <NavLink to="/setting" onClick={() => setOpen(!isOpen)}>
                    설정
                    <IcoArrow />
                  </NavLink>
                </p>
              </li>
              <li>
                <p>
                  <NavLink to="/user-guide" onClick={() => setOpen(!isOpen)}>
                    이용안내
                    <IcoArrow />
                  </NavLink>
                </p>
              </li>
            </ul>
          </nav>
        </div>
      </Container>
    </HeaderWrap>
  );
};

export default Header;

const HeaderWrap = styled.div`
  h2 {
    font-family: NanumSquareEB;
    font-size: 2rem;
    text-align: center;
    line-height: normal;
    color: ${({ theme }) => theme.color.purple_primary};
  }
  header {
    height: 6.8rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 2rem;
    div {
      width: 3.2rem;
    }
    svg {
      display: block;
    }
    -webkit-tap-highlight-color: transparent !important;
  }
  button {
    background-color: transparent;
    min-width: 3.2rem;
    &.close {
      display: flex;
      justify-content: flex-end;
    }
    -webkit-tap-highlight-color: transparent !important;
  }

  .navLogin {
    color: ${({ theme }) => theme.color.black};
    text-decoration: underline;
  }
  .panel {
    background-color: ${({ theme }) => theme.color.white};

    background-size: 100%;
    transition: all 0.4s cubic-bezier(0.42, 0, 0.34, 1.01);
    position: fixed;
    z-index: 99;
    right: -100%;
    top: 0;
    height: 100%;
    width: 100%;
    visibility: hidden;
    opacity: 0;
    overflow: scroll;

    &.open {
      visibility: visible;
      width: 100%;
      right: 0;
      opacity: 1;
    }
  }

  ul {
    li {
      list-style: none;
      font-weight: 700;
      line-height: 1.4rem; /* 87.5% */
      p {
        width: 100%;
        padding: 2.3rem 4rem;
        font-family: NanumSquareB;
      }

      a {
        width: 100%;
        display: flex;
        justify-content: space-between;
        color: ${({ theme }) => theme.color.black};
        font-family: NanumSquareB;
      }
    }
    details {
      width: 100%;
      summary {
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &::after {
          display: block;
          content: "";
          width: 1.4rem;
          height: 1.4rem;
          background: url(${IcoArrowDown});
          background-size: cover;
          background-position: center;
          margin-right: 4rem;
        }
      }
      summary::marker {
        display: none;
        content: "";
        font-size: 0;
      }
      summary::-webkit-details-marker {
        display: none;
      }
      ul {
        li {
          background-color: ${({ theme }) => theme.color.purple_bg};
          font-family: NanumSquare;
          font-size: 14px;
          font-style: normal;
          font-weight: 700;
          line-height: 14px; /* 100% */
          p {
            width: 100%;
            color: ${({ theme }) => theme.color.purple_primary};
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
        }
      }
    }
  }
`;

const InfoBox = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.color.purple_bg_dark};
  color: ${({ theme }) => theme.color.purple_dark};
  display: flex;
  justify-content: ${(props) => (props.islogin ? `space-between` : "center")};
  align-items: center;
  height: 8rem;
  padding: 0 4rem;
  color: ${(props) =>
    props.islogin ? props.theme.color.purple_dark : props.theme.color.black};
  font-family: NanumSquareB;
`;

const UserImg = styled.img`
  width: 4rem;
  height: 4rem;
  background-color: ${({ theme }) => theme.color.purple_secondary};
  border-radius: 50%;
  margin-right: 1.6rem;
  background-image: url(${UserIconImg});
`;

const PointTitle = styled.p`
  color: ${({ theme }) => theme.color.purple_secondary};
  font-size: 1.2rem;
  line-height: 1.6rem;
  text-align: right;
`;

const UserPoint = styled.p`
  font-family: NanumSquareEB;
  text-align: right;
  margin-top: 0.6rem;
  line-height: 1.6rem; /* 100% */
  display: flex;
  align-items: center;
  justify-content: end;
  span {
    text-align: right;
  }
`;
const UserIconWrap = styled.div`
  width: 3.2rem;
`;
const UserBox = styled(FlexBox)`
  width: 55%;
  .userName {
    display: flex;
    align-items: center;
    width: calc(100% - 5.6rem);
    span {
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;
const PointBox = styled.div`
  width: 40%;
  span {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 0.5rem;
  }
`;
